import {useMemo} from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import Chip from '@mui/material/Chip';

const Dependencies = ({data}) => {
    
    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: 'Dependecy Name',
            },
            {
                accessorKey: 'version',
                header: 'Version',
                accessorFn: (rowData) => {
                    return <Chip label={rowData.version} />
                }
            },
            {
                accessorKey: 'packageManager',
                header: 'Package Manager',
            }
        ],
        [],
    );
    
    const table = useMaterialReactTable({
        columns,
        data,
        enableTopToolbar: false,
        enableBottomToolbar: false,
        enablePagination: false,
        enableRowVirtualization: true,
        getRowId: (row) => row.id,
        muiTableContainerProps: {
            sx: {
                maxHeight: '250px',
            },
        },
        muiTableBodyRowProps: {
            sx: {
                height: '40px'
            },
        },
        enableColumnActions: false,
        enableColumnFilters: false,
        enableSorting: false,
    });

    return <MaterialReactTable table={table} />;
};

export default Dependencies;